/** @format */

import SettingsIcon from '@mui/icons-material/Settings';

import {ButtonBase, Link} from '@mui/material';

import {ButtonBg, Root} from './styles';

interface Props {
  color: string;
  href: string;
}

const WidgetGearButton = ({color, href}: Props) => {
  return (
    <Root>
      <ButtonBase
        disableRipple
        component={Link}
        href={href}
        target='_blank'
        rel='noopener noreferrer'
      >
        <SettingsIcon fill='#fff' fontSize='small' />
      </ButtonBase>

      <ButtonBg customColor={color} />
    </Root>
  );
};

export {WidgetGearButton};
